import decode from "jwt-decode";

var token;
export default class GeoFancingAADService {
  setGeoFancingToken(myToken) {
    token = myToken;
  }
  getGeoFancingToken() {
    return token;
  }

  getGeoFancingRoles() {
    var claims;
    if (token && null !== token) {
      claims = decode(token);
    }

    if (claims && claims.hasOwnProperty("roles")) {
      return claims.roles;
    } else {
      return null;
    }
  }

  isInRole(role) {
    if (this.getGeoFancingRoles()) {
      for (var i = 0; i < this.getGeoFancingRoles().length; i++) {
        if (this.getGeoFancingRoles()[i] === role) return true;
      }
    }
    return false;
  }
}
